import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { QuadroCompensiParcella } from '../../../models/quadro-compensi-parcella';
import { FaseCompensoParcella } from '../../../models/tipologiche/fase-compenso-parcella';
import { FaseFascicolo } from '../../../models/tipologiche/fase-fascicolo';
import { ValoriRiferimentoParcella } from '../../../models/valori-riferimento-parcella';
import { NumericOperationManager } from '../../../utils/numeric-operation-manager';
import { ParcellaAbstractForm } from '../parcella-abstract-forn';

declare var $: any;

@Component({
    selector: 'div [parcella-stragiudiziale-quadro-percentuale-form]',
  templateUrl: 'parcella-stragiudiziale-quadro-percentuale-form.html',
  // host: { '[class.col-sm-12]': '\'false\'', '[class.coldx]': '\'false\'' }
})

export class ParcellaStragiudizialeQuadroPercentualeForm extends ParcellaAbstractForm implements OnInit {
  @Output() onReturn: EventEmitter<QuadroCompensiParcella[]> = new EventEmitter<QuadroCompensiParcella[]>();
  valoriRiferimentoParcella: ValoriRiferimentoParcella[];
  fasiCompensi: FaseCompensoParcella[];

  // quadro compensi
  fasicheckedAll: boolean = false;
  mincheckedAll: boolean = false;
  medcheckedAll: boolean = false;
  maxcheckedAll: boolean = false;
  minNameRadio: string = 'mincheckaddId';
  medNameRadio: string = 'medcheckaddId';
  maxNameRadio: string = 'maxcheckaddId';
  idImporto: string = 'importoFase';
  idFaseCheck: string = 'faseCheck';
  nameRadio: string = 'minmedmaxcheckadd';
  @Input() valorePetitum: any;
  @Input() valorePercentuale: any;
  @Input() disableQuadro: boolean;
  @Input() importoBase: any;

  getSum(...args: string[]) {
    return NumericOperationManager.getSum(args);
  }

 ngOnInit(): void {
     this.createQuadroCompensi();
 }

  resetQuadroCompensi() {
    this.fasicheckedAll = false;
    this.mincheckedAll = false;
    this.medcheckedAll = false;
    this.maxcheckedAll = false;
    this.quadroCompensiGrid = [];
  }

  createQuadroCompensi(valorePercentuale?, valorePetitum?, importoBase?) {
    this.resetQuadroCompensi();
    let quadro = new QuadroCompensiParcella();
    let id = Math.random();
    quadro.fase = new FaseFascicolo();
    quadro.fase.id = '' + id;
    quadro.idImporto = this.idImporto + id;
    quadro.idFase = this.idFaseCheck + id;
    quadro.idRadioMin = this.minNameRadio + id;
    quadro.idRadioMed = this.medNameRadio + id;
    quadro.idRadioMax = this.maxNameRadio + id;
    quadro.nameRadio = this.nameRadio + id;
    this.valorePetitum = this.valorePetitum ? this.valorePetitum : (valorePetitum ? valorePetitum : 0);
    this.valorePercentuale = this.valorePercentuale ? this.valorePercentuale : (valorePercentuale ? valorePercentuale : 0);
    this.importoBase = this.importoBase ? this.importoBase : (importoBase ? importoBase : 0)
    console.log('Valore petitum:' + this.valorePetitum);
    console.log('Valore percentuale:' + this.valorePercentuale);
    quadro.valoreMedio = (this.valorePetitum / 100) * this.valorePercentuale;
    quadro.valoreMinimo = (quadro.valoreMedio) / 100 * 50;
    quadro.valoreMassimo = (quadro.valoreMedio) / 100 * 180;
    quadro.valoreMedio = parseFloat(quadro.valoreMedio.toFixed(2));
    quadro.valoreMinimo = parseFloat(quadro.valoreMinimo.toFixed(2));
    quadro.valoreMassimo = parseFloat(quadro.valoreMassimo.toFixed(2));
    let quadroPreCompilato: boolean = false;
    if (this.importoBase > 0) {
      quadroPreCompilato = true;
      quadro.compenso = '' + this.importoBase;
    }

    if (this.importoBase === quadro.valoreMinimo) {
      quadro.checkedMin = true;
      quadroPreCompilato = true;
    } else {
      quadro.checkedMin = false;
    }
    if (this.importoBase === quadro.valoreMedio) {
      quadro.checkedMed = true;
      quadroPreCompilato = true;
    } else {
      quadro.checkedMed = false;
    }
    if (this.importoBase === quadro.valoreMassimo) {
      quadro.checkedMax = true;
      quadroPreCompilato = true;
    } else {
      quadro.checkedMax = false;
    }
    quadro.idCheckboxFase = quadro.idFase + '-' + quadroPreCompilato;

    quadro.valoreMedio = NumericOperationManager.numberToString(quadro.valoreMedio.toFixed(2).toString());
    quadro.valoreMinimo = NumericOperationManager.numberToString(quadro.valoreMinimo.toFixed(2).toString());
    quadro.valoreMassimo = NumericOperationManager.numberToString(quadro.valoreMassimo.toFixed(2).toString());

    if (quadro.compenso) {
      quadro.compenso = NumericOperationManager.numberToString(quadro.compenso.toString());
    }
    console.log('valoreMedio:' + quadro.valoreMedio);
    console.log('valoreMinimo:' + quadro.valoreMinimo);
    console.log('valoreMassimo:' + quadro.valoreMassimo);
    console.log('compenso:' + quadro.compenso);
    this.quadroCompensiGrid.push(quadro);

    this.onReturn.emit(this.quadroCompensiGrid);
    // opzioni di default
    this.setFase(); // seleziono tutte le fasi
    if (!quadroPreCompilato) {
      this.setMed(); // seleziono tutti gli importi medi
    }

  }


  setFase() {
    this.fasicheckedAll = !this.fasicheckedAll;

    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedFase = this.fasicheckedAll;
      this.quadroCompensiGrid[i] = q;
      i++;
    }

    if (this.fasicheckedAll == false) {
      this.mincheckedAll = false;
      this.medcheckedAll = false;
      this.maxcheckedAll = false;
      this.disabledRadio();
    } else {
      this.abilitaRadio();
    }
  }

  setMin() {
    this.mincheckedAll = !this.mincheckedAll;
    this.medcheckedAll = false;
    this.maxcheckedAll = false;
    this.refreshMin();
  }

  refreshMin() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMed = false;
      q.checkedMax = false;
      if (q.checkedMin) {
        q.compenso = '0';
      }

      if (this.mincheckedAll == true) {
        q.checkedMin = q.checkedFase;
      } else {
        q.checkedMin = false;
      }

      if (q.checkedMin) {
        q.compenso = q.valoreMinimo;
      }
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  setMed() {
    this.medcheckedAll = !this.medcheckedAll;
    this.mincheckedAll = false;
    this.maxcheckedAll = false;
    this.refreshMed();
  }

  refreshMed() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMax = false;
      if (q.checkedMed) {
        q.compenso = '0';
      }

      if (this.medcheckedAll == true) {
        q.checkedMed = q.checkedFase;
      } else {
        q.checkedMed = false;
      }

      if (q.checkedMed) {
        q.compenso = q.valoreMedio;
      }
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  setMax() {
    this.maxcheckedAll = !this.maxcheckedAll;
    this.mincheckedAll = false;
    this.medcheckedAll = false;
    this.refreshMax();
  }

  refreshMax() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMed = false;
      if (q.checkedMax) {
        q.compenso = '0';
      }

      if (this.maxcheckedAll == true) {
        q.checkedMax = q.checkedFase;
      } else {
        q.checkedMax = false;
      }

      if (q.checkedMax) {
        q.compenso = q.valoreMassimo;
      }
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  gstRadio(id: string, isFaseChecked: boolean) {
    var ind = this.quadroCompensiGrid.findIndex(q => q.fase.id === id);
    this.quadroCompensiGrid[ind].checkedFase = isFaseChecked;
    if (!isFaseChecked) {
      this.quadroCompensiGrid[ind].checkedMin = false;
      this.quadroCompensiGrid[ind].checkedMed = false;
      this.quadroCompensiGrid[ind].checkedMax = false;
      this.quadroCompensiGrid[ind].disabledImporto = true;
    }
    this.quadroCompensiGrid[ind].disabledMin = !isFaseChecked;
    this.quadroCompensiGrid[ind].disabledMed = !isFaseChecked;
    this.quadroCompensiGrid[ind].disabledMax = !isFaseChecked;
    this.quadroCompensiGrid[ind].disabledImporto = !isFaseChecked;
    this.quadroCompensiGrid[ind].compenso = '0';
    // MODIFICA - LEANDRO
    if (!this.checkAtLeastOneFase()) {
      this.fasicheckedAll = false;
      this.mincheckedAll = false;
      this.medcheckedAll = false;
      this.maxcheckedAll = false;
      this.disableAllChecked();
    }
    // MODIFICA - LEANDRO
  }

  disableAllChecked() {
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMax = false;
      q.checkedMed = false;
    }
  }

  disabledRadio() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.checkedMin = false;
      q.checkedMed = false;
      q.checkedMax = false;
      this.quadroCompensiGrid[i] = q;
      q.disabledMin = true;
      q.disabledMed = true;
      q.disabledMax = true;
      q.compenso = '0';
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  abilitaRadio() {
    let i = 0;
    for (let q of this.quadroCompensiGrid) {
      q.disabledMin = false;
      q.disabledMed = false;
      q.disabledMax = false;
      this.quadroCompensiGrid[i] = q;
      i++;
    }
  }

  disableRadio(q: QuadroCompensiParcella) {
    if (q.checkedMin) {
      q.checkedMin = false;
    }
    if (q.checkedMed) {
      q.checkedMed = false;
    }
    if (q.checkedMax) {
      q.checkedMax = false;
    }
  }

  settaImportoFase(id: string, importo: string, faseType: number, checked: boolean) {
    if (!checked) {
      this.mincheckedAll = false;
      this.medcheckedAll = false;
      this.maxcheckedAll = false;
      var ind = this.quadroCompensiGrid.findIndex(q => q.fase.id === id);
      this.quadroCompensiGrid[ind].compenso = importo;
      if (faseType === 0 && !this.quadroCompensiGrid[ind].checkedMin) {
        this.quadroCompensiGrid[ind].checkedMin = true;
      } else {
        this.quadroCompensiGrid[ind].checkedMin = false;
      }
      if (faseType === 1 && !this.quadroCompensiGrid[ind].checkedMed) {
        this.quadroCompensiGrid[ind].checkedMed = true;
      } else {
        this.quadroCompensiGrid[ind].checkedMed = false;
      }
      if (faseType === 2 && !this.quadroCompensiGrid[ind].checkedMax) {
        this.quadroCompensiGrid[ind].checkedMax = true;
      } else {
        this.quadroCompensiGrid[ind].checkedMax = false;
      }
    }
  }

  ricalcolaTotale(): string {
    let importi: string[] = [];
    for (let q of this.quadroCompensiGrid) {
      importi.push(q.compenso ? q.compenso : '0');
    }
    //    if (this.valorePercentuale > 100) {
    //      this.valorePercentuale = 5;
    //    }
    //    if (!this.isTabella && this.valorePercentuale > 0 && importi[0] !== NumericOperationManager.getPercentuale(this.valorePetitum, this.valorePercentuale)) {
    //      importi[0] = (NumericOperationManager.getPercentuale(this.valorePetitum, this.valorePercentuale));
    //    }
    let totale = NumericOperationManager.getSum(importi);
    this.onReturn.emit(this.quadroCompensiGrid);
    return NumericOperationManager.transformToThousands(String(totale));
  }

  validate(event: any, _value: string) {
    let theEvent = event || window.event;
    let key = theEvent.keyCode || theEvent.which;
    key = String.fromCharCode(key);
    // var regex = /^[0-9]+(\,{1}[0-9]{1,2}){0,1}$/g;
    // var regex = /[0-9]|\/[^,]*/; // per inserire numeri e virgole
    // var regex = /[0-9]|\,/; // per inserire numeri e virgole OK (per� puoi inserire tante virgole)
    let regex = /^[0-9]+\,{0,1}([0-9]{1,}){0,1}$/g;
    let value = _value;
    if (!value) {
      value = '';
    }
    if (!regex.test(value + key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }
  validateChange(q: QuadroCompensiParcella) {
    // var regex = /^[0-9]+(\,{1}[0-9]{1,2}){0,1}$/g;
    // var regex = /[0-9]|\/[^,]*/; // per inserire numeri e virgole
    // var regex = /[0-9]|\,/; // per inserire numeri e virgole OK (per� puoi inserire tante virgole)
    let regex = /^[0-9]+\,{0,1}([0-9]{1,}){0,1}$/g;
    let value = q.compenso;
    if (!value) {
      value = '';
    }
    if (!regex.test(value)) {
      q.compenso = '';
    }
  }

}
